import { useEffect, useState } from "react";
import { func, string } from "prop-types";
import { MAX_WORK_TYPE_LENGTH } from "@repo/utils";
import { useEstimateEditorSettings, useEstimateTableSettings } from "@tools";
import { TextClearInput } from "@components";
import classnames from "classnames";

export const TitleInput = ({
  title,
  onChange,
  placeholder,
}) => {
  const { allowEdition, useProfitability } = useEstimateEditorSettings();
  const { useExpandCell } = useEstimateTableSettings();
  
  const [ value, setValue ] = useState(title)
  const [ focused, setFocused ] = useState(false);
  
  useEffect(() => {
    setValue(title);
  }, [ title ]);
  
  const handleTitleChange = (v) => {
    setValue(v);
  };
  
  const commitTitleChange = () => {
    onChange(value || title);
    setValue(value || title);
    setFocused(false);
  }
  
  const handleTitleFocus = () => setFocused(true);
  
  if(!allowEdition || useProfitability)
    return (
      <span className={ classnames(
        "preset-summaryTitleText",
        !useExpandCell && "ml-3"
      )}>
        { value }
      </span>
    )
  
  return (
    <TextClearInput
      value={value}
      focused={focused}
      onFocus={handleTitleFocus}
      onChange={handleTitleChange}
      onAccept={commitTitleChange}
      acceptOnClickAway
      confirmOnEnter
      placeholder={placeholder}
      containerClass="name"
      className={classnames("w-max -m-0-5", !useExpandCell && "ml-2")}
      maxLength={MAX_WORK_TYPE_LENGTH}
      preventClickAwayOnElement="#workTypeSelector"
    />
  )
}

TitleInput.propTypes = {
  title: string.isRequired,
  onChange: func.isRequired,
  placeholder: string.isRequired,
};